<template>
	<div>
		<div class="title row">
			<div>
    			<h1>Résultats de recherche pour: <span class="green">{{ query }}</span><i class="fa fa-refresh fa-spin" aria-hidden="true"></i></h1>
			</div>
		</div>
		<div class="row main-wrap">
			<div class="col-md-12">
				<a href="javascript:history.back()">
					<button class="big-button"><i class="fa fa-chevron-left" aria-hidden="true"></i> Retour</button>
				</a>
			</div>
			<div class="col-md-12">
				<table class="table table-striped table-bordered desktop" v-if="results && results.length > 0">
					<thead>
						<tr>
							<th class="empty"></th>
							<th>Nom</th>
							<th>Client</th>
							<th>Entite</th>
							<th>Date</th>
							<th>Temps</th>
							<th>Categorie</th>
							<th>Type</th>
							<th>Theme</th>
							<th>Commentaire Time-sheet</th>
							<th>Position defendue</th>
							<th>Decision publique</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="result in results">
							<td class="empty">
								<div class="search-actions">
									<router-link :to="{ path: '/hatvp/' + result.idclient + '/' + result.year }">
										<i v-if="result.hatvp == 1" class="fa fa-balance-scale" aria-hidden="true"></i>
									</router-link>
									<router-link :to="{ path: '/timesheet/' + result.idclient + '/' + result.year + '/' + result.month}">
										<i class="fa fa-calendar" aria-hidden="true"></i>
									</router-link>
								</div>
							</td>
							<td>{{ result.utilisateur.user.name }}</td>
							<td>{{ result.client.user.name }}</td>
							<td>
								<template v-if="result.entite">
									{{ result.entite.name }}
								</template>
							</td>
							<td>{{ result.dateclean }}</td>
							<td>{{ result.temps }}</td>
							<td>
								<template v-if="result.action_categorie">
									{{ result.action_categorie.name }}
								</template>
							</td>
							<td>{{ result.action_type.name }}</td>
							<td>{{ result.action_theme }}</td>
							<td>{{ result.action_commentaire }}</td>
							<td>{{ result.action_position_defendue }}</td>
							<td>{{ result.decision_publique }}</td>
						</tr>
					</tbody>
				</table>
				<div class="no-results" v-else-if="results && results.length == 0 && this.searchDone === true">
					<p>
						Pas de résultats pour: <span class="green">{{ query }}</span>
					</p>
				</div>
				<div class="no-results" v-else>
					<p>
						Recherche en cours pour: <span class="green">{{ query }}</span>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import Vue from '../js/app.js'
import reportings from '../js/reporting.js';

export default {
  	data() {
    	return {
			query: this.$route.params.info,
			searchDone : false,
			results: null,
		}
    },
    beforeCreate: function() {
		if (this.$route.params.info && this.$route.params.info !== '') {
			reportings.search(this, this.$route.params.info);
		}
    }
}
</script>

<style lang="scss">
   @import '../sass/app.scss';
</style>



// WEBPACK FOOTER //
// Recherche.vue?2b4d8aa0